import React, { useEffect, useState } from 'react';
import { Input, Label } from '../../css/Shared';
import { useAppContext } from '../../context/AppContext';
import States from '../../components/States';
import api from '../../components/Api';
import { toast } from 'react-toastify';

const MailOwner = ({
  onClose,
  owner,
  setOwners,
  setReset,
  reset,
  onCreated
}) => {
  const { authState } = useAppContext();

  const [formData, setFormData] = useState({
    name: '',
    companyName: '',
    address: '',
    address2: '',
    city: '',
    state: 'FL',
    zip: '',
    crid: '',
    mid: '',
    nonprofitnumber: '',
    anywhere: '',
    company: authState?.user.company,
  });

  /* ✅ MATCH MailProvider PATTERN */
  useEffect(() => {
    if (owner) {
      setFormData({
        ...owner,
        company: authState?.user.company,
      });
    }
  }, [owner?._id]); // 👈 critical fix

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
const isUpdate = Boolean(owner);
    try {
      const endpoint = owner
        ? '/permits/updatemailowner'
        : '/permits/addmailowner';

      const payload = owner
        ? { ...formData, id: owner._id } // 👈 SAME as MailProvider
        : formData;
 const res = await api.post(endpoint, payload);

    toast.success(isUpdate ? 'Mail Owner updated' : 'Mail Owner saved');

    if (onCreated) {
      onCreated(res.data);
    }

    if (!onCreated && typeof setOwners === 'function') {
      setOwners([]);
    }

    if (!onCreated && typeof setReset === 'function') {
      setReset(!reset);
    }
      onClose();
    } catch (err) {
      console.error(err.response?.data || err);
    }
  };

  return (
    <div className="
      max-h-[80vh]
      overflow-y-auto
      max-w-6xl
      mx-auto
      px-6
      py-4
      text-sm
      [&_input]:h-9
      [&_input]:text-sm
      [&_input]:px-3
      [&_label]:text-xs
    ">
      <form onSubmit={handleSubmit} className="space-y-6">

        <h2 className="text-base font-semibold text-gray-800">
          {owner ? 'Edit Mail Owner' : 'New Mail Owner'}
        </h2>

        <InputGroup
          label="Mail Owner Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
        />

        <Section title="Mail Owner Information">
          <div className="grid grid-cols-1 md:grid-cols-6 gap-4">

            <div className="md:col-span-6">
              <InputGroup label="Company Name" name="companyName" value={formData.companyName} onChange={handleChange} />
            </div>

            <div className="md:col-span-3">
              <InputGroup label="Address 1" name="address" value={formData.address} onChange={handleChange} />
            </div>

            <div className="md:col-span-3">
              <InputGroup label="Address 2" name="address2" value={formData.address2} onChange={handleChange} />
            </div>

            <div className="md:col-span-3">
              <InputGroup label="City" name="city" value={formData.city} onChange={handleChange} />
            </div>

            <div className="md:col-span-1">
              <Label muted>State</Label>
              <States setFormData={setFormData} formData={formData} />
            </div>

            <div className="md:col-span-2">
              <InputGroup label="Zip" name="zip" value={formData.zip} onChange={handleChange} />
            </div>

          </div>
        </Section>

        <Section title="Postal Information">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <InputGroup label="CRID" name="crid" value={formData.crid} onChange={handleChange} />
            <InputGroup label="MID" name="mid" value={formData.mid} onChange={handleChange} />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
            <InputGroup label="Nonprofit Authorization #" name="nonprofitnumber" value={formData.nonprofitnumber} onChange={handleChange} />
            <InputGroup label="Mail Anywhere Account #" name="anywhere" value={formData.anywhere} onChange={handleChange} />
          </div>
        </Section>

        <div className="flex justify-end gap-3 pt-2">
          <button type="button" onClick={onClose} className="btn-secondary">
            Cancel
          </button>
          <button type="submit" className="btn-primary">
            Save
          </button>
        </div>

      </form>
    </div>
  );
};

/* helpers — EXACT SAME AS MailProvider */

const Section = ({ title, children }) => (
  <section className="border rounded-lg p-4">
    <h3 className="text-xs font-medium text-gray-500 mb-3 uppercase tracking-wide">
      {title}
    </h3>
    {children}
  </section>
);

const InputGroup = ({ label, name, value, onChange }) => (
  <div>
    <Label muted>{label}</Label>
    <Input name={name} value={value} onChange={onChange} />
  </div>
);

export default MailOwner;
